import TFrame from './frame.vue'
export default TFrame



// WEBPACK FOOTER //
// ./src/frame/index.js